import { useRouteError } from "react-router-dom";

export default function ErrorBoundary() {
    const error: any = useRouteError();
    

    return (
        <div className="min-h-screen bg-page-base text-content-primary flex flex-col items-center justify-center p-8 text-center font-sans">
            <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
            </div>
            <h1 className="text-3xl font-bold mb-4">System Error</h1>
            <p className="text-white/60 mb-8 max-w-md">
                {error?.statusText || error?.message || "An unexpected error occurred."}
            </p>
            <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-white text-black rounded-lg font-bold hover:bg-gray-200 transition-colors"
            >
                Reload System
            </button>
        </div>
    );
}
